import { apiInstance } from "v2/infrastructure/common/api/apiClient";

const sendApproveBenefitRequest = async ({
  companyId,
  requestId,
}: {
  companyId: string;
  requestId: string;
}): Promise<void> => {
  await apiInstance.put(
    `/v1/companies/${companyId}/benefit-requests/${requestId}/state`,
    { action: "approve" }
  );
};

export default sendApproveBenefitRequest;
